import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

export const printerRoutes: RouteRecordRaw[] = [
  {
    path: '/printer',
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'PrinterTools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'printer.list' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'list',
            name: 'printer.list',
            component: () =>
              import('@/modules/operationsTools/printers/ui/view/printerList.vue')
          },
          {
            path: 'statuses',
            name: 'printer.statuses',
            component: () =>
              import('@/modules/operationsTools/printers/ui/view/printerStatusesList.vue')
          },
          {
            path: 'dashboard',
            name: 'printer.dashboard',
            component: () =>
              import('@/modules/operationsTools/printers/ui/view/printerMonitor.vue')
          }
        ]
      }
    ]
  }
]
